import { useState } from 'react';

import { Add } from '@mui/icons-material';
import { Box, Button, Grid, Typography } from '@mui/material';
import { useSettingsStore } from 'app/store';
import { useParams } from 'react-router-dom';

import { AddCashdesk } from 'features/add-cashdesk';
import { CashDeskItem } from 'features/cash-desk-item';

import { ROLES } from 'shared/constants';
import { useUser } from 'shared/hooks';
import { useCustomNavigate } from 'shared/hooks/useCustomNavigate';
import { TCashdesk } from 'shared/services/types/cashdesk.types';
import { HeaderWrapper } from 'shared/ui/header-wrapper';
import { Layout } from 'shared/ui/layout';
import { RoleAccessWrapper } from 'shared/ui/role-access-wrapper';

import { useGetCashdesks } from '../api';
import { MOCK_DATA_CASH_DESK } from '../mock-data/MOCK_DATA';

export const CashDesk = () => {
  const { darkTheme } = useSettingsStore();
  const cashDeskData = MOCK_DATA_CASH_DESK;
  const { user } = useUser();
  const { customNavigate } = useCustomNavigate();
  const { method_id } = useParams();
  const { cashdesks: cashdesksItems } = useGetCashdesks();

  const [isOpen, setIsOpen] = useState(false);
  const [modalType, setModalType] = useState<'info' | ''>('');
  const [cashdeskItem, setCashdeskItem] = useState<
    TCashdesk.CashdeskData | TCashdesk.CreateCashdesk
  >();
  const [currentMethod, setCurrentMethod] = useState<number>(parseInt(method_id!));

  const onOpenModal = (
    modalType: 'info' | '',
    data?: TCashdesk.CashdeskData | TCashdesk.CreateCashdesk
  ) => {
    setIsOpen(true);
    setModalType(modalType);
    setCashdeskItem(data);
  };

  const onCloseModal = () => {
    setIsOpen(false);
    setModalType('');
  };

  return (
    <Layout>
      <HeaderWrapper>
        <Box
          sx={{
            flexGrow: '1',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 10,
            borderRadius: 4,
            '.MuiButton-root': {
              padding: ' 10px 28px 10px 24px',
              minWidth: 'fit-content',
              maxHeight: 44,
              fontSize: 16,
              fontWeight: 500,
              letterSpacing: '0.25px',
              '&.MuiButton-contained': {
                fontSize: '14px',
                fontWeight: '400'
              }
            }
          }}>
          <Box
            sx={{
              flexGrow: 1,
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: '14px'
            }}>
            <Typography
              variant='h3'
              color='primary'
              sx={{ fontSize: 28, lineHeight: '36px', fontWeight: '500' }}>
              Cash desk
            </Typography>
          </Box>
          <RoleAccessWrapper accessCondition={ROLES.CashDesk.canCreate} currentRole={user?.role}>
            <Button
              variant='contained'
              startIcon={<Add />}
              onClick={() => {
                onOpenModal('', undefined);
              }}>
              Add cash desk
            </Button>
          </RoleAccessWrapper>
        </Box>
      </HeaderWrapper>
      <Box
        gridRow={'2/4'}
        gridColumn={'2'}
        sx={{
          borderRadius: '16px',
          overflow: 'scroll',
          maxHeight: 'calc(100% - 24px)'
        }}>
        <Grid container spacing={6}>
          {(cashDeskData || []).map(data => {
            const totalMethods = data.methods.length;
            const totalAgents = data.methods.map(i => i.count).reduce((a, c) => a + c, 0);
            return (
              <CashDeskItem
                cashdeskItemData={data}
                key={data.name}
                onOpenModal={onOpenModal}
                totalAgents={totalAgents}
                totalMethods={totalMethods}
              />
            );
          })}
        </Grid>
      </Box>
      <AddCashdesk
        isOpen={isOpen}
        dataCreate={cashdeskItem as TCashdesk.CreateCashdesk}
        dataInfo={cashdeskItem as TCashdesk.CashdeskData}
        modalType={modalType}
        onClose={onCloseModal}
      />
    </Layout>
  );
};
